import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useDispatch, useSelector } from 'react-redux';

import { AddDeliveryAddressModal } from './AddDeliveryAddressModal';
import { SingleDeliveryAddressBox } from './SingleDeliveryAddressBox';
import { fetchUserDeliveryAddresses } from '../../../../../api/user-api';
import {
  selectDeliveryAddress,
  setDeliveryAddress,
} from '../../../../../features/order/deliveryAddressSlice';

const DeliveryAddress = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedAddressId, setSelectedAddressId] = useState(null);

  const dispatch = useDispatch();
  const deliveryAddress = useSelector(selectDeliveryAddress);
  const { data: user } = useSelector((state) => state.user);
  const latestAddress = user?.latest_address;

  const { data, isLoading, isError } = useQuery({
    queryKey: ['useraddresses'],
    queryFn: fetchUserDeliveryAddresses,
  });

  const addresses = data?.data?.data || [];

  // Set default (latest) address if none selected
  useEffect(() => {
    if (!setDeliveryAddress && latestAddress) {
      setSelectedAddressId(latestAddress.id);
      dispatch(setDeliveryAddress(latestAddress));
    }
  }, [latestAddress, selectedAddressId, dispatch]);

  // Handle user selecting another address
  const handleSelectAddress = (address) => {
    setSelectedAddressId(address.id);
    dispatch(setDeliveryAddress(address));
  };

  return (
    <section>
      <h1 className="font-semibold text-[23px]">Delivery Address</h1>
      <hr className="mt-5 mb-7" />
      <div className="grid lg:flex lg:space-x-5">
        <p className="font-duplet mb-4 lg:mb-0">Your delivery addresses</p>
        <div>
          {isLoading && <div className="skeleton md:w-[345px] h-[95px]" />}

          {isError && (
            <p className="w-full py-20 px-20 rounded-md bg-[#F6F6F6] text-center text-gray-500 flex justify-center items-center">
              Failed to load addresses
            </p>
          )}

          {!isLoading && !isError && (
            <>
              {addresses.length === 0 ? (
                <p className="text-sm text-gray-500">
                  No delivery addresses found
                </p>
              ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {addresses.map((address) => (
                    <SingleDeliveryAddressBox
                      key={address.id}
                      address={address}
                      onSelectedAddress={handleSelectAddress}
                      selectedAddressId={selectedAddressId}
                    />
                  ))}
                </div>
              )}

              <p
                className="font-medium text-sm font-duplet underline mt-8 cursor-pointer"
                onClick={() => setIsModalOpen(true)}
              >
                Add another delivery address
              </p>

              {isModalOpen && (
                <AddDeliveryAddressModal
                  onClose={() => setIsModalOpen(false)}
                />
              )}
            </>
          )}
        </div>
      </div>
    </section>
  );
};

export default DeliveryAddress;
